import script from "./InputComponent.vue?vue&type=script&setup=true&lang=ts"
export * from "./InputComponent.vue?vue&type=script&setup=true&lang=ts"

import "./InputComponent.vue?vue&type=style&index=0&id=2504547a&lang=css"

const __exports__ = script;

export default __exports__